<template>
  <div class="tenant-confirm-block">
    <p class="tenant-confirm">{{ $t(`tenantConfirms.${regionName}.topOfPage_p1`) }}</p>
    <p class="tenant-confirm">{{ $t(`tenantConfirms.${regionName}.topOfPage_p2`) }}</p>
    <p class="tenant-confirm">{{ $t(`tenantConfirms.${regionName}.topOfPage_p3`) }}</p>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('regions', ['regionName']),
  },
}
</script>

<style lang="scss" scoped>
.tenant-confirm-block {
  .tenant-confirm {
    color: #878787;
    font-style: italic;
  }
}
</style>
